import { useCreateMachine } from 'fsm';
import { createContext, useCallback, useContext, useMemo } from 'react';
import { machine } from './machine';
import { CurrentUser } from './CurrentUser';
import { jsx as _jsx } from "react/jsx-runtime";
const nullishUser = new CurrentUser(null);
const CurrentUserContext = /*#__PURE__*/createContext(nullishUser);
const CurrentUserDataLifecycleContext = /*#__PURE__*/createContext({
  isLoading: false,
  isRefreshing: false,
  refresh: () => {}
});
export function CurrentUserProvider({
  children
}) {
  const {
    state,
    send
  } = useCreateMachine(machine);
  const refresh = useCallback(() => {
    send({
      type: 'REFRESH'
    });
  }, [send]);
  const dataLifecycle = useMemo(() => {
    return {
      refresh,
      isLoading: state.hasTag('loading'),
      isRefreshing: state.hasTag('refreshing')
    };
  }, [refresh, state]);
  return /*#__PURE__*/_jsx(CurrentUserDataLifecycleContext.Provider, {
    value: dataLifecycle,
    children: /*#__PURE__*/_jsx(CurrentUserContext.Provider, {
      value: state.context.currentUser,
      children: children
    })
  });
}
export function useCurrentUser() {
  const context = useContext(CurrentUserContext);
  if (context === undefined) {
    throw new Error('useCurrentUser must be used within CurrentUserProvider');
  }
  return context;
}
export function useCurrentUserDataLifecycle() {
  const context = useContext(CurrentUserDataLifecycleContext);
  if (context === undefined) {
    throw new Error('useCurrentUserDataLifecycle must be used within CurrentUserProvider');
  }
  return context;
}